







































import { Component, Mixins } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import { AuthModule } from "@/store/auth.module";

@Component({})
export default class PassChangedView extends Mixins(FormValidator) {
  public async clickBack() {
    await AuthModule.setEnter_types(1);
    this.$router.replace("/auth");
  }
}
